/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useRef} from "react";
import {ItemType} from "../services/types";
import {clearPendingBooking, peekPendingBooking} from "../services/pendingBooking";
import {useAPI} from "./useAPI";

/**
 * Completes a booking a guest started before signing in: once they are back on the
 * page holding that item, it is booked automatically.
 */
export const usePendingBooking = (loaded: boolean, items: ItemType[], book: (uuid: string) => Promise<unknown>) => {
  const api = useAPI();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current || !loaded || !api.loggedIn) {
      return;
    }

    const pending = peekPendingBooking();
    if (!pending || !items.some((item) => item.uuid === pending.itemUuid)) {
      return;
    }

    handled.current = true;
    clearPendingBooking();
    book(pending.itemUuid);
  }, [loaded, items, api.loggedIn]);
};
